import React from 'react';
import resolvePath from '../../../misc/resolvePath';
import Link from '../Link';
import ChatIcon from './inner/ChatIcon';

export default class TopBar extends React.Component {
    render() {
        let {returnURL} = this.props,
            classes = ['topbar'],
            style = {},
            icons = this.props.icons || [<ChatIcon selected={this.props.chat} key="chat" />];

        var returnButton;
        if (returnURL || this.props.onReturnClick || this.props.showLogo) {
            let returnButtonClasses = ['return'];
            if (this.props.showLogo) {
                returnButtonClasses.push('logo');
            }

            if (returnURL && returnURL.match(/^\./) && 'app' in window) {
                returnURL = resolvePath(app.history.location.pathname, returnURL);
            }

            if (this.props.onReturnClick) {
                returnButton = <Link onClick={this.props.onReturnClick.bind(this)} className={returnButtonClasses.join(' ')} />;
            } else if (returnURL) {
                returnButton = <Link href={returnURL} className={returnButtonClasses.join(' ')} />;
            } else {
                returnButton = <div className={returnButtonClasses.join(' ')} />;
            }
        }

        if (this.props.customColor) {
            style.background = this.props.customColor;
        }

        return (
            <div className={classes.join(' ')} style={style}>
                {returnButton}
                <div className="title">{this.props.children}</div>
                <div className="icons">{icons}</div>
            </div>
        );
    }
}
